import React, { Fragment, useState } from 'react';
import { ProgramRequestModal } from '../academic-affair-program-requests/components/ProgramRequestModal';
import eventEmitter from '../../shared/eventEmitter';

/*
* TABS SHOULD AT MINIMUM HAVE ID AND LABEL FOR EACH OBJECT
* all else is optional
*     const tabs = [
        { id: 'submitted', label: 'Submitted', count: 294 },
        { id: 'review', label: 'Under Review', count: 20 },
        { id: 'approved', label: 'Approved', count: 5 },
        { id: 'denied', label: 'Denied', count: 5 },
    ];
 * includedButtonText: string to include on button. if no string is provided, button will not show
 *
 */
export const TabBar = ({
    tabs,
    activeTab,
    onTabChange,
    includedButtonText = '',
}) => {
    const [modalActive, setModalActive] = useState(false);
    return (
        <Fragment>
            <div className="header-tab-bar">
                <div className="row align-items-center">
                    <div className="col">
                        <ul className="nav underline-tabs" role="tablist">
                            {tabs.map(tab => (
                                <li className="nav-item-tab" key={tab.id}>
                                    <button
                                        className={`nav-link-tab ${activeTab === tab.id ? 'show active' : ''
                                            }`}
                                        onClick={() => onTabChange(tab.id)}
                                    >
                                        {tab.label}{' '}
                                        {tab.count != null && tab.count !== '' && (
                                            <span className="text-muted">
                                                ({tab.count})
                                            </span>
                                        )}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                    {includedButtonText !== '' && (
                        <div className="col-auto d-flex" style={{ gap: '0.5rem' }}>
                            <button
                                type="button"
                                data-toggle="modal"
                                data-target="#new-request"
                                className="btn btn-success new-btn"
                                onClick={() => setModalActive(true)}
                            >
                                <i className="far fa-plus"></i> {includedButtonText}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <ProgramRequestModal
                isOpen={modalActive}
                toggle={() => setModalActive(false)}
                onSuccess={() => eventEmitter.emit('updateSARData')}
            />
        </Fragment>
    );
};
